import {TranslateService} from "@ngx-translate/core";
import {NavigationEnd, Router} from "@angular/router";

export class TranslationService
{
    protected languages:string[] = ['en', 'fr'];
    private currentLanguage:string = null;

    constructor(protected translate: TranslateService, protected router: Router){

    }

    public Initialize(currentUrl:string){
        this.translate.addLangs(this.languages);
        this.translate.setDefaultLang('fr');
        this.SetInitializeLanguage(currentUrl);

        this.router.events.subscribe((value) => {
            if(value instanceof NavigationEnd){
                let url = value.url;
                this.UpdateCurrentLanguage(url);
            }
        });
    }

    public CurrentLanguage():string {
        return this.currentLanguage;
    }

    public Languages():Array<string>{
        return this.languages;
    }

    private SetInitializeLanguage(url:string){
        this.UpdateCurrentLanguage(url);

        if(this.currentLanguage != null){
            return;
        }

        let userLanguage = this.FindUserLanguage();
        for(let i = 0 ; i < this.languages.length ; ++i){
            if(this.languages[i] == userLanguage){
                this.UseLanguage(this.languages[i]);
                break;
            }
        }

        if(this.currentLanguage == null){
            this.translate.use('fr');
        }
    }

    private FindUserLanguage(): string{
        let userLang = navigator.language;
        if(userLang == null){
            userLang = "";
        }
        return userLang.toLowerCase();
    }

    private UpdateCurrentLanguage(url:string){
        for(let i = 0 ; i < this.languages.length ; ++i){
            if(url.endsWith("/" + this.languages[i])){
                this.UseLanguage(this.languages[i]);
                break;
            }
        }
    }

    private UseLanguage(language:string){
        if(this.currentLanguage != language) {
            this.translate.use(language);
            this.currentLanguage = language;
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/translation/TranslationService.ts